import { FC } from 'react';
import { FormContainer, useFormContext } from 'react-hook-form-mui';
import { AuthHeading, BackButton, Button, Input, Spinner, ErrorUnderForm } from 'view/components';
import {
  AuthHeadingImageTypeEnums,
  commonEmailValidationRules,
  getCommonPasswordValidationRules,
  parseError,
} from 'view/pages/auth/helpers';
import {
  AuthFormsFooter,
  Agreement,
  Separator,
  GoogleLoginButton,
} from 'view/pages/auth/components';
import { useLoginWithEmail } from 'view/pages/auth/hooks/useLoginWithEmail';
import * as CS from 'view/pages/auth/commonStyled';
import * as S from './styled';

interface IFormInput {
  email: string;
  password: string;
}

const LoginFormFields: FC<{ isLoading: boolean; error: any }> = ({ isLoading, error }) => {
  const {
    formState: { errors },
  } = useFormContext<IFormInput>();

  const isDisabled = !!errors.email || !!errors.password || isLoading;

  return (
    <>
      <Input
        name="email"
        label="Email"
        type="email"
        rules={commonEmailValidationRules}
        parseError={parseError}
      />
      <Input
        name="password"
        label="Password"
        type="password"
        rules={getCommonPasswordValidationRules('Password')}
        parseError={parseError}
      />
      {error ? <ErrorUnderForm /> : null}
      <S.FormWrapperForgotLink href="/auth/forgot">Forgot Password?</S.FormWrapperForgotLink>
      <CS.FormWrapperMain component="div">
        <Button
          variant="contained"
          type="submit"
          text="Log In"
          endIcon={isLoading ? <Spinner disabled={isDisabled} variant="contained" /> : null}
          disabled={isDisabled}
        />
        <Separator />
        <GoogleLoginButton variant="outlined" />
        <Agreement />
      </CS.FormWrapperMain>
    </>
  );
};

const LoginPage: FC = () => {
  const { isLoading, error, send } = useLoginWithEmail();

  const onSubmit = (formData: IFormInput) => {
    send(formData);
  };

  return (
    <CS.Wrapper>
      <CS.BackButtonBox>
        <BackButton text="Back to Authorization" fallbackUrl="/auth/onboarding" />
      </CS.BackButtonBox>
      <CS.AuthMainBox component="section">
        <AuthHeading
          title="Welcome back!"
          subTitle={'We are happy to see you back. \n Please Log In to continue'}
          imageType={AuthHeadingImageTypeEnums.LINE}
        />
        <CS.FormWrapper component="section">
          <FormContainer defaultValues={{ email: '', password: '' }} onSuccess={onSubmit}>
            <LoginFormFields isLoading={isLoading} error={error} />
          </FormContainer>
          <AuthFormsFooter
            title="New to Injobnito?"
            hrefTo="/auth/registration"
            hrefText="Join Now"
          />
        </CS.FormWrapper>
      </CS.AuthMainBox>
    </CS.Wrapper>
  );
};

export default LoginPage;
